var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5755,12.792H7.55737a.44864.44864,0,0,0-.44427.45288v4.15094a.44436.44436,0,1,0,.88855,0V15.77313H8.5755a1.49084,1.49084,0,0,0,0-2.98114Zm0,2.0755H8.00165v-1.1698H8.5755a.585.585,0,0,1,0,1.1698Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7384,12.79242H15.70221a.44863.44863,0,0,0-.44428.45282v4.151a.44433.44433,0,1,0,.88849,0V15.35846h.77747a.4529.4529,0,0,0,0-.90564h-.77747v-.7547h1.592a.45293.45293,0,0,0,0-.9057Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.44427,12.79242h-.81451a.44857.44857,0,0,0-.44421.45282v4.151a.44857.44857,0,0,0,.44421.45282h.81451a2.27806,2.27806,0,0,0,2.07319-2.52832A2.2785,2.2785,0,0,0,12.44427,12.79242Zm0,4.15094H12.074V13.69812h.37023c.66626,0,1.1847.662,1.1847,1.62262C13.629,16.28192,13.11084,16.94336,12.44427,16.94336Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.18427,7.25958a.45319.45319,0,0,0-.09552-.14581L15.20184,2.13263a.44589.44589,0,0,0-.14288-.09741A.43688.43688,0,0,0,14.8877,2H4.29944a.44854.44854,0,0,0-.44422.45282V21.54718A.44858.44858,0,0,0,4.29944,22H19.7746a.44857.44857,0,0,0,.44421-.45282V7.434A.45963.45963,0,0,0,20.18427,7.25958ZM15.332,3.54608l3.37012,3.43506H15.332ZM4.74371,21.0943V2.90564h9.69971V7.434a.44863.44863,0,0,0,.44428.45282h4.44262V21.0943Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.14b973facb8bcdb323f6a11be101e74e.svg";
export { ForwardRef as ReactComponent };